import { render, staticRenderFns } from "./ms-MY.vue?vue&type=template&id=33a1e5a2&"
import script from "./ms-MY.vue?vue&type=script&lang=js&"
export * from "./ms-MY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a1e5a2')) {
      api.createRecord('33a1e5a2', component.options)
    } else {
      api.reload('33a1e5a2', component.options)
    }
    module.hot.accept("./ms-MY.vue?vue&type=template&id=33a1e5a2&", function () {
      api.rerender('33a1e5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/ms-MY.vue"
export default component.exports